module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/119.12b19f79.png";